import "core-js/modules/es6.string.starts-with";
import Vue from "vue";
import VueRouter from "vue-router";
import * as Data from "@/data";
import routes from "./routes";
import readOnly from "../boot/readOnly";
Vue.use(VueRouter);
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

export default function ()
/* { store, ssrContext } */
{
  var Router = new VueRouter({
    scrollBehavior: function scrollBehavior() {
      return {
        x: 0,
        y: 0
      };
    },
    routes: routes,
    // Leave these as is and change from quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });
  Router.beforeEach(function (to, from, next) {
    readOnly.SetReadOnlyValue(false); // Check if route requires authentication (skip login/public routes)

    var publicRoutes = ["/Login", "/ForgotPassword", "/ResetPassword", "/Register", "/CertifiedManagementCompanyAgentList", "/AffordableHousingLocator", "/AffordableHousinglocator/SearchResults"];
    var isPublicRoute = publicRoutes.some(function (route) {
      return to.path.toLowerCase().startsWith(route.toLowerCase());
    }); // Redirect to login if not authenticated and trying to access protected route

    if (!isPublicRoute && !Data.Authentication.TokenValid()) {
      next({
        path: "/Login",
        query: {
          returnUrl: to.fullPath
        }
      });
      return;
    }

    if (to.meta.manualReadOnly) {
      to.meta.manualReadOnly = false;
      next(to);
    } else if (Data.Authentication.IsMHDCUser() && to.path == "/") {
      next({
        path: "projects"
      });
    } else if (!to.meta.readOnly && Data.Authentication.IsMHDCReadOnly()) {
      to.meta.readOnly = true;
      next(to);
    } else if (!Data.Authentication.IsMHDCUser(true) && to.meta.Permission) {
      var propertyId = parseInt(to.params.propertyId) || parseInt(to.params.projectId);
      var hasRead = false;
      var hasWrite = false;

      if (propertyId) {
        hasWrite = Data.Authentication.HasWritePropertyPermission(to.meta.Permission, propertyId);
        hasRead = Data.Authentication.HasReadPropertyPermission(to.meta.Permission, propertyId);
      } else {
        hasWrite = Data.Authentication.HasWritePermission(to.meta.Permission);
        hasRead = Data.Authentication.HasReadPermission(to.meta.Permission);
      }

      if (Data.Authentication.TokenValid() && !hasRead && !hasWrite) {
        next({
          path: "/"
        });
      } else if (!to.meta.readOnly && hasRead && !hasWrite) {
        to.meta.readOnly = true;
        next(to);
      } else {
        next();
      }
    } else {
      next();
    }
  });
  return Router;
}